import BaseService from './BaseService'
import { api } from '@/boot/axios'

class FulfillmentService extends BaseService {
  constructor() {
    super('/fulfillments')
  }

  async listForInvoice(invoiceId) {
    const { data } = await api.get(`/invoices/${invoiceId}/fulfillments`)
    return data
  }

  async createForInvoice(invoiceId, payload) {
    const { data } = await api.post(`/invoices/${invoiceId}/fulfillments`, payload)
    return data
  }

  async delete(id) {
    const { data } = await api.delete(`/fulfillments/${id}`)
    return data
  }
}

export default new FulfillmentService()


